import { useState, useContext, useEffect, useRef } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { Businesses } from 'lib/api';
import { CustomerContext } from 'context/customers/customersContext';
import { CUSTOMERS_ACTIONS } from 'context/customers/customersReducer';
import { numberFormat } from 'helpers/i18n';
import SnackBarComponent from 'components/shared/SnackBarComponent';
import './DeactivateCustomerModal.css';

const { HIDE_DEACTIVATE_MODAL, RELOAD_CUSTOMERS } = CUSTOMERS_ACTIONS;

const DeactivateCustomerModal = () => {
    const {
        state: { isDeactivateModalOpen, selectedCustomer },
        dispatch
    } = useContext(CustomerContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const SnackBarRef = useRef(null);

    useEffect(() => {
        if (!isDeactivateModalOpen) {
            setErrorMessage('');
        }
    }, [isDeactivateModalOpen]);

    const handleCancelClick = () => {
        dispatch({ type: HIDE_DEACTIVATE_MODAL });
    };

    const handleDeactivateCustomer = async () => {
        setIsSubmitting(true);

        try {
            await Businesses.deactivate(selectedCustomer.id_business);

            SnackBarRef.current.openSnackBar({
                label: 'Customer deactivation successful',
                severity: 'success'
            });
            dispatch({ type: RELOAD_CUSTOMERS });
            setIsSubmitting(false);
            dispatch({ type: HIDE_DEACTIVATE_MODAL });
        } catch (error) {
            setIsSubmitting(false);
            setErrorMessage(error?.response?.data?.message || 'An unexpected error ocurred. Please try again.');
        }
    };

    return (
        <>
            <Dialog open={isDeactivateModalOpen} onClose={() => {}} maxWidth="xs">
                <DialogContent sx={{ padding: '32px', width: '384px' }}>
                    <Box sx={{ marginBottom: '32px' }}>
                        <Box>
                            <Typography className="data-label">Business ID:</Typography>
                            <Typography className="text-secondary">{selectedCustomer?.id_business}</Typography>
                        </Box>
                        <Box>
                            <Typography className="data-label">Business name:</Typography>
                            <Typography className="text-secondary">{selectedCustomer?.legal_name}</Typography>
                        </Box>
                        <Box>
                            <Typography className="data-label">Admin name:</Typography>
                            <Typography className="text-secondary">
                                {selectedCustomer?.first_name} {selectedCustomer?.last_name}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography className="data-label">Current spend limit:</Typography>
                            <Typography className="text-secondary">
                                {numberFormat(selectedCustomer?.credit_limit || 0)}
                            </Typography>
                        </Box>
                    </Box>

                    <Box>
                        <Typography className="form-title">Deactivate this customer?</Typography>
                    </Box>
                    <Box>
                        <Typography className="text-secondary">The account and all its cards will be disabled</Typography>
                    </Box>

                    {errorMessage && <Typography className="text-error">{errorMessage}</Typography>}

                    <DialogActions sx={{ marginTop: '32px', padding: '0px' }}>
                        <Button
                            variant="outlined"
                            sx={{ color: '#7D95A5', borderColor: '#7D95A5' }}
                            onClick={handleCancelClick}
                            disabled={isSubmitting}>
                            Cancel
                        </Button>

                        <Button type="submit" variant="contained" onClick={handleDeactivateCustomer} disabled={isSubmitting}>
                            {isSubmitting ? <CircularProgress size="20px" /> : 'Confirm'}
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <SnackBarComponent ref={SnackBarRef} />
        </>
    );
};

export default DeactivateCustomerModal;
